module.exports = __webpack_public_path__ + "static/media/otkat_vorota.65da9482.jpg";